import { memo } from 'react';
import { condColor, condType, decodeCond, COND_ICONS, COND_NAMES } from '../engine/conditions';

/** The icon drawn for a condition code: by its type (a located one by its base), else by its name; null if none. */
function iconFor(code) {
  const ct = condType(code);
  const iconKey = ct.includes(':') ? ct.split(':')[0] : ct;
  return COND_ICONS[iconKey] || COND_ICONS[COND_NAMES[iconKey]] || null;
}

/** An icon path's paint: a stroked line in the text colour, or a fill in the text or background colour. */
function pathPaint(el, cc) {
  if (el.stroke) return { fill: 'none', stroke: cc.text, strokeWidth: 1.5 };
  return { fill: el.bg ? cc.bg : cc.text, stroke: 'none', strokeWidth: 0 };
}

// `onClick` defaults so the prop is OPTIONAL: the battlefield draws
// these as inert decoration, and a chip that took the pointer would
// silently enlarge a marker's hit area.
function ConditionIcon({ code, size, onClick = undefined }) {
  const icon = iconFor(code);
  if (!icon) return null;
  const cc = condColor(code);
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default', display: 'block' }}
      role="img"
      aria-label={decodeCond(code)}
    >
      <rect width={size} height={size} rx={3} fill={cc.bg} stroke={cc.border} strokeWidth={0.8} />
      <title>{decodeCond(code)}</title>
      <g transform={`translate(${size * 0.1},${size * 0.1}) scale(${(size * 0.8) / 16})`}>
        {icon.map((el, i) => (
          <path key={i} d={el.d} {...pathPaint(el, cc)} strokeLinecap="round" strokeLinejoin="round" />
        ))}
      </g>
    </svg>
  );
}

export default memo(ConditionIcon);
